module.exports = __webpack_public_path__ + "static/media/image_7.3bb8d953.png";